import React from "react"
import Bio from '../components/bio'
import Layout from '../components/layout'

export default () => (
  <Layout title= "Home">
    <Bio/>
  </Layout>
)
